<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="role in roleList" :value="role.id" :label="role.description" :key="role.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      roleList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchRoleList () {
      this.isLoading = false
      var call = '/getPEARoleList'
      this.$axios.get(call).then(response => {
        const unsortedList = response.data
        const sortedList = unsortedList.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase()) ? 1 : -1)
        this.roleList = sortedList
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        helperMethods.showNotification(this.$parent.$parent.$parent.$parent, 'Error getting Role List', reject.body, 'error', 30000, '')
      })
    }
  },
  created () {
    this.fetchRoleList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
